import { TagType, entities } from "../../../util/uiconstants";

export const SampleItemFilterConfiguration = {
	tags: {
		endpoint: 'tags',
		entityFilter: (entityFilters) => ({
			engagementId: entityFilters.engagementId,
			entityId: entities.SampleItem,
			filterTagCategory: TagType.FilteringNotArchived
		}),
		entityMapping: (response) => {
			let tags = response?.data
			?.filter((x) => x.engagementTagId)
			.sort(function(a, b) {
				return (
					(a.engagementTagGroupName ?? '').localeCompare(b.engagementTagGroupName ?? '') ||
					(a.engagementTagName ?? '').localeCompare(b.engagementTagName ?? '')
				);
			})
			.map((item) => ({
				value: '#' + item.engagementTagId.toString(),
				label: item.engagementTagName,
				group: item.engagementTagGroupName
			}));

		return tags;
		},
		getDisplayValue: (id, entityType, _filterData) => {
			let value;

			if (_filterData?.store && _filterData?.store[entityType].byId && _filterData?.store[entityType].byId[id]) {
				value = _filterData?.store[entityType]?.byId[id].label;
			}

			return value;
		}
	}
};

export const FilterEntityConfiguration = {
	...SampleItemFilterConfiguration
};
